var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccountViewInfo = function SvgAccountViewInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/16*16/informative/information",
    clipPath: "url(#clip0_9084_88336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46617 4.98404C9.46617 5.35223 9.16769 5.65071 8.7995 5.65071C8.43131 5.65071 8.13284 5.35223 8.13284 4.98404C8.13284 4.61585 8.43131 4.31738 8.7995 4.31738C9.16769 4.31738 9.46617 4.61585 9.46617 4.98404Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7995 2.25038C5.44898 2.25038 2.73284 4.96652 2.73284 8.31705C2.73284 11.6676 5.44898 14.3837 8.7995 14.3837C12.15 14.3837 14.8662 11.6676 14.8662 8.31705C14.8662 4.96652 12.15 2.25038 8.7995 2.25038ZM1.53284 8.31705C1.53284 4.30378 4.78623 1.05038 8.7995 1.05038C12.8128 1.05038 16.0662 4.30378 16.0662 8.31705C16.0662 12.3303 12.8128 15.5837 8.7995 15.5837C4.78623 15.5837 1.53284 12.3303 1.53284 8.31705ZM7.53284 7.31738C7.53284 6.98601 7.80147 6.71738 8.13284 6.71738H8.7995C9.13087 6.71738 9.3995 6.98601 9.3995 7.31738L9.3995 11.6504C9.3995 11.9818 9.13087 12.2504 8.7995 12.2504C8.46813 12.2504 8.1995 11.9818 8.1995 11.6504L8.1995 7.91738H8.13284C7.80147 7.91738 7.53284 7.64875 7.53284 7.31738Z",
    fill: "#475467"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9084_88336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.798828 0.317383)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccountViewInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "accountViewInfo.a598bcd12791af0f2cb0cd64b5564fdc.svg";